<template>
  <figure v-if="true">
    <ul id="slides" ref="slides" class="mx-3 mt-3 mb-2 px-0 component-slider" :class="[{music:
                   this.globalResources.portalType === this.portalType.Music, 'header-break' :
      portalGeneralInfo.hasHeader}]">
      <li v-for="(image, index) in items"
          :key="index"
          :data-order="image.isMain && isDesktop() ? 100 : index"
          class="slide card-shadow"
          :class="{'primary': image.isMain, 'simple': !image.isMain}">
        <div
          class="position-relative w-100"
          v-if="portalGeneralInfo.Skin === 'cloob' || portalGeneralInfo.Skin === 'jabe'" 
          >
          <img 
          :src="fileUrl(getImage(image.src, image.isMain))">
          <b-link
          :href="getTargetUrlType(image.targetUrl) === 'href' ? image.targetUrl : ''"
          :to="getTargetUrlType(image.targetUrl) === 'route' ? image.targetUrl : ''"
          :target="getTargetUrlType(image.targetUrl) === 'href' ? '_blank' : '_self'"
          @click="trackGaEvent(image.isMain,image.targetUrl)">
            <div
            class="start-game"
              >
              {{ $t('product.startGame')}}
            </div>
          </b-link>
          <div v-if="!isDesktop() && (portalGeneralInfo.Skin === 'cloob')" class="slider-dots">
            <div  v-for="(dot, index) in dots" :key="index" :id="`dot${index}`" 
                  class="dot" :class="{'active' : dot.isActive }"></div>
          </div>
        </div>
        <b-link 
          v-else 
          :href="getTargetUrlType(image.targetUrl) === 'href' ? image.targetUrl : ''"
          :to="getTargetUrlType(image.targetUrl) === 'route' ? image.targetUrl : ''"
          :target="getTargetUrlType(image.targetUrl) === 'href' ? '_blank' : '_self'"
          @click="trackGaEvent(image.isMain,image.targetUrl)">
          <img :src="fileUrl(getImage(image.src, image.isMain))">
        </b-link>
      </li>
    </ul>
  </figure>
  <div v-else class="component-slider">
    <figure id="Slider">
      <ul id="slides" ref="slides">
        <li v-for="(image, index) in items"
            :key="index"
            class="slide"
            :class="{main: image.isMain, primary: image.isMain,fadein: !image.isMain && index == 1, fadeout: !image.isMain && index > 3}">
          <b-link :href="getTargetUrlType(image.targetUrl) === 'href' ? image.targetUrl : ''"
                  :to="getTargetUrlType(image.targetUrl) === 'route' ? image.targetUrl : ''"
                  :target="getTargetUrlType(image.targetUrl) === 'href' ? '_blank' : '_self'">
            <img :src="fileUrl(image.src)">
          </b-link>
        </li>
      </ul>
      <ul id="sliderControl" ref="sliderControl">
        <li v-for="(image, index) in items"
            :key="index"
            class="slider-trigger slidercontrol"
            :class="{active: index === 0}"
            @click="goToSelectedSlide(index)" />
      </ul>
    </figure>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import enums from '@/utilities/enums.js'
  import windowSize from '@/mixins/window-size'

  export default {
    name: 'Slider',
    mixins: [windowSize, enums],
    props: {
      items: {
        type: Array,
        default: () => []
      },
      interval: {
        type: Number,
        default: 5000
      }
    },
    data() {
      return {
        desktopSliderAnimation: Object,
        handheldSliderAnimation: Object,
        currentSlideIndex: 0,
        primaryImageWidth: 1397,
        simpleImageWidth: 445,
        dots: [],
        dotIndex: 0
      }
    },
    computed: {
      ...mapGetters({
        fileUrl: 'cdn/fileUrl',
        portalConfig: 'tenantDesign/config'
      }),
      portalGeneralInfo () {
        return this.portalConfig.general
      },
      sliderDotsLength() {
        return this.items.length ? this.items.length : 4
      }
    },
    mounted() {
      this.generateSliderDots()
      this.changeSliderOnScreenResize()
      this.initializeSlider()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.initializeSlider)
    },
    destroyed() {
      clearInterval(this.desktopSliderAnimation)
      clearInterval(this.handheldSliderAnimation)
    },
    methods: {
      getImage(src, isMain) {
        var self = this
        var size =
          (self.isMaxWidth768() && !self.isMaxWidth480())
            ? '?w=768'
            : (self.isDesktop() && isMain) || self.isTablet()
              ? '?w=1000'
              : '?w=480'

        var result = src + size

        return result
      },
      goToSelectedSlide(index) {
        let self = this
        let slides = self.$refs.slides
        let selectedSlide = slides.children[index]
        let sliderControls = self.$refs.sliderControl
        let selectedButton = sliderControls.children[index]
        let slidesCount = slides.children.length

        for (let i = 0; i < slidesCount; i++) {
          let slide = slides.children[i]
          slide.classList.remove('fadein')
          slide.classList.add('fadeout')
          sliderControls.children[i].classList.remove('active')
        }

        selectedSlide.classList.remove('fadeout')
        selectedSlide.classList.add('fadein')
        selectedButton.classList.add('active')

        event.stopPropagation()
      },

      animateDesktopSlide() {
        let self = this

        self.desktopSliderAnimation = setInterval(
          () => self.initializeDesktopSlides(),
          self.interval
        )
      },
      resetSliderIndex() {
        var self = this
        var slides = self.$refs.slides
        var slideCounts = slides.children.length
        for (var index = 0; index < slideCounts; index++) {
          var slide = slides.children[index]
          slide.setAttribute('data-order', index)
        }
      },
      initializeDesktopSlides() {
        var self = this
        var slides = self.$refs.slides
        var slideCounts = slides.children.length

        for (let index = 0; index < slideCounts; index++) {
          var slide = slides.children[index]

          if (slide.classList.contains('simple')) {
            var order = slide.getAttribute('data-order')

            if (order >= slideCounts - 1) {
              slide.setAttribute('data-order', 1)
            } else {
              slide.setAttribute('data-order', parseInt(order) + 1)
            }
          } else {
            slide.setAttribute('data-order', 100)
          }
        }
      },
      initializeHandheldSlides() {
        var self = this
        var slides = self.$refs.slides
        var slideCounts = slides.children.length

        for (let index = 0; index < slideCounts; index++) {
          var slide = slides.children[index]
          var order = slide.getAttribute('data-order')

          if (order >= slideCounts - 1) {
            slide.setAttribute('data-order', 0)
          } else {
            slide.setAttribute('data-order', parseInt(order) + 1)
          }
        }
      },
      animateHandheldSlide() {
        let self = this

        this.handheldSliderAnimation = setInterval(
          () => { 
            self.initializeHandheldSlides()
            self.dotsInterval()
          },
          this.interval
        )
      },
      resetSliderTimer() {
        var self = this
        self.resetSliderIndex()
        clearInterval(self.desktopSliderAnimation)
        clearInterval(self.handheldSliderAnimation)
      },

      initializeSlider() {
        var self = this
        self.resetSliderTimer()
        self.resetSliderIndex()

        if (self.isDesktop()) {
          self.animateDesktopSlide()
        } else {
          self.animateHandheldSlide()
        }
      },
      changeSliderOnScreenResize() {
        window.addEventListener('resize', this.initializeSlider)
      },
      getTargetUrlType(src) {
        if (src.startsWith('http')) {
          return 'href'
        }
        return 'route'
      },
      trackGaEvent(isMainImage, imageTargetUrl) {
        if (isMainImage) {
          this.$ga.event('Collection', 'SliderBigClick', imageTargetUrl)
        } else {
          this.$ga.event('Collection', 'SliderSmallClick', imageTargetUrl)
        }
      },
      generateSliderDots() {
        for (var i = 0; i < this.sliderDotsLength; i++) {
          this.dots.push({
            id: `dot${i}`,
            isActive: false
          })
        }
        this.dots[0].isActive = true
      },
      dotsInterval() {
        var previous = this.dotIndex
        this.dotIndex = (this.dotIndex + 1) % 4;
        this.dots[this.dotIndex].isActive = true
        this.dots[previous].isActive = false
      }
    }
  }
</script>
